// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._189ee4h9{border-width:var(--ds-border-width,1px)}\n._195gv77o{margin-inline:var(--ds-space-025,2px)}\n._1dqonqa1{border-style:solid}\n._1h6dmuej{border-color:var(--ds-border,#091e4224)}\n._19pk12x7{margin-top:var(--ds-space-075,6px)}", ""]);
// Exports
module.exports = exports;
